<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="people"
    ></vuse-section-definition>

    <v-container fluid class="">
      <template>
        <v-card>
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ clientDetail.companyName }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon class="content-ma-0" v-on="on">
                  <v-icon small>mdi-cogs</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="isEditable" v-show="!isEditable">
                  <v-list-item-title>
                    <v-icon small left>mdi-pencil</v-icon>Edit
                  </v-list-item-title>
                </v-list-item>

                <v-list-item>
                  <v-list-item-title>
                    <v-icon small left>delete</v-icon>Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <template v-slot:extension>
              <v-tabs v-model="tab" align-with-title>
                <v-tabs-slider color="yellow"></v-tabs-slider>

                <v-tab> General </v-tab>
                <v-tab> Jobs </v-tab>
                <v-tab> Bids </v-tab>
                <v-tab> Notes </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-form ref="form" @submit.prevent="save()">
                <v-card class="pa-5" flat>
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td class="font-weight-bold" width="20%">Company</td>
                          <td>
                            <div v-if="!isEditable">{{ form.companyName }}</div>
                            <v-text-field
                              v-else
                              v-model="form.companyName"
                              dense
                              :hide-details="
                                [].concat(
                                  fieldErrors('form.companyName'),
                                  serverSideErrors('CompanyName')
                                ).length === 0
                              "
                              :error-messages="
                                [].concat(
                                  fieldErrors('form.companyName'),
                                  serverSideErrors('CompanyName')
                                )
                              "
                              @blur="$v.form.companyName.$touch()"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">First Name</td>
                          <td>
                            <div v-if="!isEditable">{{ form.firstName }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.firstName"
                                dense
                                :hide-details="
                                  [].concat(
                                    fieldErrors('form.firstName'),
                                    serverSideErrors('FirstName')
                                  ).length === 0
                                "
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.firstName'),
                                    serverSideErrors('FirstName')
                                  )
                                "
                                @blur="$v.form.firstName.$touch()"
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Last Name</td>
                          <td>
                            <div v-if="!isEditable">{{ form.lastName }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.lastName"
                                dense
                                :hide-details="
                                  [].concat(
                                    fieldErrors('form.lastName'),
                                    serverSideErrors('LastName')
                                  ).length === 0
                                "
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.lastName'),
                                    serverSideErrors('LastName')
                                  )
                                "
                                @blur="$v.form.lastName.$touch()"
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Email</td>
                          <td>
                            <div v-if="!isEditable">{{ form.email }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.email"
                                dense
                                hide-details
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Phone Number</td>
                          <td>
                            <div v-if="!isEditable">{{ form.phoneNumber }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.phoneNumber"
                                dense
                                hide-details
                                v-mask="`(###) ###-####`"
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Address</td>
                          <td>
                            <div v-if="!isEditable">{{ form.address }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.address"
                                dense
                                hide-details
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">City</td>
                          <td>
                            <div v-if="!isEditable">{{ form.city }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.city"
                                dense
                                hide-details
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">State</td>
                          <td>
                            <div v-if="!isEditable">{{ form.state }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.state"
                                dense
                                hide-details
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Zipcode</td>
                          <td>
                            <div v-if="!isEditable">{{ form.zipcode }}</div>
                            <div v-else>
                              <v-text-field
                                v-model="form.zipcode"
                                dense
                                hide-details
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-card-actions v-show="editMode">
                    <v-row>
                      <v-col> </v-col>
                      <v-col class="text-right">
                        <v-btn @click="cancel()" class="mr-5">Cancel</v-btn>
                        <v-btn color="info">Save</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-tab-item>
            <v-tab-item>
              <v-card class="pa-5" flat>
                <v-card-text>Jobs by Client ID</v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card class="pa-5" flat>
                <v-card-text>Bids by Client ID</v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UTIL from "src/helpers/utility";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

export default {
  data: () => ({
    namespace: "Client Info",
    page: "Client Info",
    usage: "usage",
    tab: null,
    editMode: false,
    addMode: false,
    form: {
      companyName: "",
      firstName: "",
      lastName: "",
    },
  }),

  mixins: [validationMixin],
  validations: {
    form: {
      companyName: {
        required,
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
    },
  },

  validationMessages: {
    form: {
      companyName: {
        required: "Required",
      },
      firstName: {
        required: "Required",
      },
      lastName: {
        required: "Required",
      },
    },
  },

  async mounted() {
    if (this.clientId) {
      await this.getById(this.clientId);
    } else {
      this.addMode = true;
    }
  },

  computed: {
    ...mapState({
      client: (state) => state.client,
    }),

    clientDetail() {
      return this.client.single;
    },

    clientId() {
      return UTIL.gv(this.$route, "params.id", "");
    },

    isEdit() {
      return this.clientId ? true : false;
    },

    isEditable() {
        return this.editMode || this.addMode;
    }
  },

  watch: {
    clientDetail(n) {
      this.form = n;
    },
  },

  methods: {
    ...mapActions("client", ["create", "update", "getById"]),

    serverSideErrors(field) {
      //   return UTIL.gv(this.userGroup.errors, field, []);
      console.log(field);
      return [];
      //   return [field];
    },

    async refresh() {
      await this.getById(this.$route.params.id);
    },

    async cancel() {
      await this.refresh();
      this.editMode = false;
    },

    async save() {
      let payload = {
        ...this.form,
      };

      if (this.isEdit) {
        await this.update(payload);
      } else {
        await this.create(payload);
      }

      console.log(this.client);

      this.cancel();
    },

    back() {
      this.$router.push("/clients");
    },
  },
};
</script>
